<template>
  <div class="bg-weed bg-no-repeat bg-cover bg-fixed">
    <div class="fixed h-full w-full bg-theme-overlaydark opacity-80"></div>
    <div class="flex flex-col min-h-screen overflow-hidden relative z-0">
      <!-- header fixed part -->
      <div class="flex bg-theme-grey h-[100px] login-header">
        <div class="ml-4 my-auto inline-block">
          <svg width="50" height="50" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.2771 10.1888L23.8023 19.7587C24.3641 20.7318 23.6618 21.9482 22.5381 21.9482L13.3069 21.9482L13.3069 10.1888L18.2771 10.1888Z" fill="white"/>
                <path d="M10.736 0.782108C11.2979 -0.191042 12.7025 -0.191041 13.2644 0.78211L17.0922 7.41213H6.9082L10.736 0.782108Z" fill="#B0EDAE"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.355 11.2836L1.14586 20.3061C1.0054 20.5493 1.18098 20.8534 1.4619 20.8534L9.59827 20.8534L9.59826 11.2836L6.355 11.2836ZM0.197744 19.7587L5.72292 10.1888L10.6931 10.1888L10.6931 21.9482L1.4619 21.9482C0.338206 21.9482 -0.364105 20.7318 0.197744 19.7587Z" fill="white"/>
          </svg>
        </div>
      </div>

      <div class="flex w-full login-body">
        <div class="mx-auto mt-12 py-[5px]">
          <slot name="basecontent"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";

// import PasswordSetup from "./PasswordSetup.vue";
export default defineComponent({
  name: "LoginBase",
  components: {
  },
  setup() {
  },
});
</script>
<style>

.login-body {
  min-height: calc(100vh - 100px);
}
</style>
